import { type HTMLAttributes } from 'react'
import { twMerge } from 'tailwind-merge'

export interface DialogContentProps extends HTMLAttributes<HTMLDivElement> {}

export const DialogContent = ({ className, ...props }: DialogContentProps) => (
  <div className={twMerge('text-md space-y-3', className)} {...props} />
)

DialogContent.displayName = 'DialogContent'
